// File: main.js

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Import the router
import store from "./store";

const app = createApp(App);

app.use(router); // Use the router
app.use(store);

app.mount("#app");
